import React from "react";
import { Carousel } from "antd";
import { sliderData } from "../../data/SiteData";
function Testimonals(props) {
  return (
    <section id="testimonials" class="testimonials">
      <div class="container " data-aos="zoom-in">
        <Carousel autoplay easing="linear" speed={1500} dots={false}>
          {sliderData.map((item) => {
            return (
              <div class="swiper-slide ">
                <div class="testimonial-item">
                  <img src={item.image} class="testimonial-img" alt="" />
                  <h3>{item.name}</h3>
                  <h4>{item.title}</h4>
                  <p>
                    <i class="bx bxs-quote-alt-left quote-icon-left"></i>
                    {item.description}
                    <i class="bx bxs-quote-alt-right quote-icon-right"></i>
                  </p>
                </div>
              </div>
            );
          })}
        </Carousel>

        <div class="swiper-pagination"></div>
      </div>
    </section>
  );
}

export default Testimonals;
